const parallaxItems = document.querySelectorAll('.parallax');
let ticking = false;

const isElementInView = (element) => {
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom >= 0;
};

const updateParallaxItems = () => {
  const scrollPos = window.scrollY;
  parallaxItems.forEach((item) => {
    const rect = item.getBoundingClientRect();
    if (isElementInView(item)) {
      const distanceFromTop = rect.top;
      const parentWidth = Math.min(item.parentElement.offsetWidth, 1000);
      const distanceEntered = scrollPos - distanceFromTop;
      let coefficient = 20_000_000
      if (window.devicePixelRatio > 1) {
        coefficient /= window.devicePixelRatio;
      }
      const offset = Math.max(0, distanceEntered * parentWidth / coefficient); // Increase the denominator to slow down the parallax effect
      item.style.transform = `translateY(${-offset}px) scale(${1 + offset})`; // scale proportionally with offset
    }
  });
  ticking = false;
};

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(updateParallaxItems);
    ticking = true;
  }
});
